/* frontend/src/utils/websocket.js */
export const createWebSocket = (articleId, onMessage) => {
  const ws = new WebSocket(`${process.env.REACT_APP_WS_URL}/ws/article/${articleId}/`);
  
  ws.onopen = () => console.log(`WebSocket connected for article ${articleId}`);
  ws.onmessage = (e) => {
    const data = JSON.parse(e.data);
    onMessage(data);
  };
  ws.onclose = () => console.log(`WebSocket disconnected for article ${articleId}`);
  ws.onerror = (error) => console.error('WebSocket error:', error);

  return ws;
};
